export default {
  scenes: {
    aMomentOfVictory: {
      beats: {
        theCountdownEnds: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weaponControlRoom'
            },
            {
              type: 'showNarration',
              text: 'With seconds to spare, Elena manages to stop the countdown and disarm Nyx\'s weapon. As the control room goes silent, the crew breathes a collective sigh of relief. Nyx, defeated but defiant, is taken into custody. The team regroups, their faces a mixture of exhaustion and triumph. The universe is safe, for now.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena react to their success?',
              choices: [
                {
                  text: 'Acknowledge the Team\'s Efforts',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'acknowledgeTeam'
                  }
                },
                {
                  text: 'Reflect Alone on the Battle',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'reflectAlone'
                  }
                }
              ]
            }
          ]
        },
        acknowledgeTeam: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'We did it. This was a team effort. You all saved the day.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'happy',
              text: 'Can\'t say I didn\'t enjoy the rush.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'theReconciliation'
          }
        },
        reflectAlone: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We did it… but at what cost?'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'We all made it out, Elena. That\'s what matters.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'theReconciliation'
          }
        },
        theReconciliation: {
          events: [
            {
              type: 'showLocation',
              locationId: 'commandCenter'
            },
            {
              type: 'showNarration',
              text: 'In the aftermath of the battle, Elena is left to reflect on the journey she\'s been through. Zara, who has shown her loyalty in the final moments, approaches Elena in the quiet of the command center. It\'s clear there\'s unfinished business between them. Zara seeks to apologize for her past actions, wanting to make amends for her betrayal.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena respond to Zara\'s apology?',
              choices: [
                {
                  text: 'Forgive Zara and Move Forward',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'forgiveZara'
                  }
                },
                {
                  text: 'Reject Zara\'s Apology and Keep Her Distance',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'rejectZara'
                  }
                }
              ]
            }
          ]
        },
        forgiveZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'ve both made mistakes, Zara. But we can\'t keep living in the past.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'happy',
              text: 'I\'m just glad you\'re willing to let me prove I\'ve changed.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'kaelsConcern'
          }
        },
        rejectZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'I don\'t know if I can ever trust you again.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I understand. I just wanted to make things right.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'kaelsConcern'
          }
        },
        kaelsConcern: {
          events: [
            {
              type: 'showNarration',
              text: 'After the mission\'s success, Kael pulls Elena aside, clearly worried about her well-being. They\'ve both been through so much, and he can see that Elena is not as okay as she lets on. Their bond has grown stronger, but now he\'s unsure where they stand, especially with the shadow of Nyx\'s betrayal looming over them.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena respond to Kael\'s concern?',
              choices: [
                {
                  text: 'Open Up to Kael',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'openUpToKael'
                  }
                },
                {
                  text: 'Push Kael Away',
                  next: {
                    scene: 'aMomentOfVictory',
                    beat: 'pushKaelAway'
                  }
                }
              ]
            }
          ]
        },
        openUpToKael: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'sad',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'sad',
              text: 'I don\'t know if I can keep doing this, Kael. The weight of all of it is too much.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'happy',
              text: 'You don\'t have to carry it alone. I\'m here for you, Elena.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'choosingTheFuture'
          }
        },
        pushKaelAway: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'I appreciate your concern, Kael, but I can handle this on my own.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'sad',
              text: 'If that\'s what you need, I\'ll respect it. But you don\'t have to be alone.'
            }
          ],
          next: {
            scene: 'aMomentOfVictory',
            beat: 'choosingTheFuture'
          }
        },
        choosingTheFuture: {
          events: [
            {
              type: 'showLocation',
              locationId: 'elenasQuarters'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'It\'s time to decide. What kind of leader—and person—do I want to be now?'
            }
          ],
          next: {
            scene: 'movingForward',
            beat: 'aNewPath'
          }
        }
      }
    },
    movingForward: {
      beats: {
        aNewPath: {
          events: [
            {
              type: 'showLocation',
              locationId: 'commandCenter'
            },
            {
              type: 'showNarration',
              text: 'In the wake of everything, Elena has made her decision. She addresses her crew, telling them of her plans for the future. No longer burdened by Nyx\'s threat, she is ready to rebuild and look to a brighter future. With a newfound sense of purpose, Elena considers her next mission, one that involves peace and rebuilding what was lost.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena present her new direction?',
              choices: [
                {
                  text: 'Lead with Optimism',
                  next: {
                    scene: 'movingForward',
                    beat: 'leadWithOptimism'
                  }
                },
                {
                  text: 'Lead with Caution',
                  next: {
                    scene: 'movingForward',
                    beat: 'leadWithCaution'
                  }
                }
              ]
            }
          ]
        },
        leadWithOptimism: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'The fight is over, but our journey doesn\'t end here. It\'s time to rebuild and chart a course for a better future.'
            },
            {
              type: 'showNarration',
              text: 'Crew: (cheering) We\'re with you, Captain.'
            }
          ],
          next: {
            scene: 'movingForward',
            beat: 'aNewBeginning'
          }
        },
        leadWithCaution: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'ve been through a lot, and it\'s not over yet. But we\'ve got a chance to make things right.'
            },
            {
              type: 'showNarration',
              text: 'Crew: (nodding) We\'ll take it one step at a time, Captain.'
            }
          ],
          next: {
            scene: 'movingForward',
            beat: 'aNewBeginning'
          }
        },
        aNewBeginning: {
          events: [
            {
              type: 'showNarration',
              text: 'As Elena\'s crew rallies around her, they head toward their next mission—one focused on diplomacy and healing across the galaxy. Elena feels a sense of peace as she looks ahead, but she knows that this journey will be full of challenges. Still, she is ready to face them with her team by her side.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'Together, we\'ll make this work. Let\'s take the first step toward peace.'
            }
          ],
          goToChapter: {
            chapter: 'chapter6'
          }
        }
      }
    }
  }
}
